import { SettlementDto } from '../services/surveySettlement.service';

// Helper function to escape CSV values
function escapeCSVValue(value: any): string {
  if (value === null || value === undefined) {
    return '';
  }
  
  let stringValue = Array.isArray(value) ? value.join('; ') : String(value);
  
  // Escape quotes and wrap in quotes if contains special characters
  if (stringValue.includes('"') || stringValue.includes(',') || stringValue.includes('\n')) {
    stringValue = '"' + stringValue.replace(/"/g, '""') + '"';
  }
  
  return stringValue;
}

// Helper function to flatten the nested SettlementDto structure
function flattenSettlementProfile(profile: SettlementDto): Record<string, any> {
  return {
    // Settlement Identity
    'Village Name': profile.settlement_identity.village_name,
    'District': profile.settlement_identity.district,
    'Council': profile.settlement_identity.council,
    'Latitude': profile.settlement_identity.coordinates.latitude,
    'Longitude': profile.settlement_identity.coordinates.longitude,
    
    // Basic Scale
    'Total Households': profile.basic_scale.total_households,
    'Estimated Population': profile.basic_scale.estimated_population,
    'Distance to Grid (km)': profile.basic_scale.distance_to_grid_km,
    'Template Type': profile.basic_scale.template_type,
    
    // NES Planning Classification
    'Recommended Electrification Approach': profile.nes_planning_classification.recommended_electrification_approach,
    'NES Tag': profile.nes_planning_classification.nes_tag,
    'Display Label': profile.nes_planning_classification.display_label,
    
    // Public and Economic Profile
    'Public Facilities': profile.public_and_economic_profile.public_facilities,
    'Marketplaces Count': profile.public_and_economic_profile.marketplaces_count,
    'Average Traders Per Market': profile.public_and_economic_profile.average_traders_per_market,
    'Main Livelihood Activities': profile.public_and_economic_profile.main_livelihood_activities,
    'Main Productive Use Activities': profile.public_and_economic_profile.main_productive_use_activities,
    'Main Commercial Activities': profile.public_and_economic_profile.main_commercial_activities,
    
    // Access and Readiness Summary
    'Existing Electricity Infrastructure': profile.access_and_readiness_summary.existing_electricity_infrastructure,
    'Mobile Money Available': profile.access_and_readiness_summary.mobile_money_available,
    'Readiness Notes': profile.access_and_readiness_summary.readiness_notes,
    
    // Storytelling Fields
    'Headline Tag': profile.storytelling_fields.headline_tag,
    'Short Description': profile.storytelling_fields.short_description,
    'Why This Village Matters': profile.storytelling_fields.why_this_village_matters,
    'Photo URL': profile.storytelling_fields.photo,
    
    // Metadata
    'Created At': profile.created_at,
    'Updated At': profile.updated_at,
  };
}

export function downloadSettlementProfile(profile: SettlementDto) {
  const fileName = `${profile.settlement_identity.village_name.toLowerCase().replace(/ /g, '-')}-profile.json`;
  const blob = new Blob([JSON.stringify(profile, null, 2)], { type: 'application/json;charset=utf-8' });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}

export function downloadSettlementProfileAsCSV(profile: SettlementDto) {
  const fileName = `${profile.settlement_identity.village_name.toLowerCase().replace(/ /g, '-')}-profile.csv`;
  const flatProfile = flattenSettlementProfile(profile);
  
  // Create CSV headers
  const headers = Object.keys(flatProfile);
  const headerRow = headers.map(escapeCSVValue).join(',');
  
  // Create CSV data row
  const dataRow = headers.map(key => escapeCSVValue(flatProfile[key])).join(',');
  
  // Combine headers and data
  const csvContent = [headerRow, dataRow].join('\n');
  
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8' });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}
